import {
  axiosDeleteRequest,
  axiosGetRequest,
  axiosPostRequest,
  axiosPutRequest,
  getHealthPictureRoute,
  getReferenceRoute,
} from '../../api';
import { BodyPartFirstLevel, BodyPartSecondLevel, BodyType } from '../model';
import { Symptom, SymptomSearchResult } from './model';

export const SEARCH_RESULTS_MAX = 20;

export const searchSymptomsCall = (searchString: string) => {
  const encodedSearchString = encodeURIComponent(searchString);
  return axiosGetRequest<SymptomSearchResult[]>(
    `${getReferenceRoute()}/symptoms/${encodedSearchString}/${SEARCH_RESULTS_MAX}`
  );
};

export const fetchSymptomsCall = (healthJourneyId: string) => {
  return axiosGetRequest<Symptom[]>(
    `${getHealthPictureRoute()}/symptoms/${healthJourneyId}`
  );
};

export const fetchSymptomsByTypeCall = (
  healthJourneyId: string,
  symptomType: string
) => {
  return axiosGetRequest<Symptom[]>(
    `${getHealthPictureRoute()}/symptoms/${healthJourneyId}/symptomtype/${symptomType}/-1`
  );
};

export const insertSymptomsCall = (symptoms: Symptom[]) => {
  return axiosPostRequest<Symptom[], Symptom[]>(
    `${getHealthPictureRoute()}/symptoms`,
    symptoms
  );
};

export const updateSymptomCall = (symptom: Symptom) => {
  return axiosPutRequest<Symptom, Symptom>(
    `${getHealthPictureRoute()}/symptoms`,
    symptom
  );
};

export const deleteSymptomCall = (symptomId: string) => {
  return axiosDeleteRequest<string, void>(
    `${getHealthPictureRoute()}/symptoms/${symptomId}`
  );
};

export const searchSymptomsByBodyPartCall = (
  bodyType: BodyType,
  front: boolean,
  bodyPartFirstLevel: BodyPartFirstLevel,
  bodyPartSecondLevel: BodyPartSecondLevel
) => {
  const gender = bodyType === BodyType.A ? 'F' : 'M';
  const frontback = front ? 'F' : 'B';
  return axiosGetRequest<SymptomSearchResult[]>(
    `${getReferenceRoute()}/bodypartsymptoms?gender=${gender}&frontback=${frontback}&level1=${bodyPartFirstLevel}&level2=${
      bodyPartSecondLevel.name
    }`
  );
};

export const fetchSecondLevelBodyPartsCall = (
  bodyType: BodyType,
  front: boolean,
  bodyPartFirstLevel: BodyPartFirstLevel
) => {
  const gender = bodyType === BodyType.A ? 'F' : 'M';
  const frontback = front ? 'F' : 'B';
  return axiosGetRequest<BodyPartSecondLevel[]>(
    `${getReferenceRoute()}/bodypartlevel2?gender=${gender}&frontback=${frontback}&level1=${bodyPartFirstLevel}`
  );
};
